import { useState } from 'react';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { statement: '', correct: true };

export default function TrueFalseEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [statement, setStatement] = useState(initial.statement || '');
   const [correct, setCorrect] = useState(initial.correct !== false);

   const handleSave = () => onSave({ text: statement, config: JSON.stringify({ statement, correct }) });

   return (
      <div className='exercise-block-true-false-editor'>
         <RichTextEditor rows={2} value={statement} placeholder='Твердження' onChange={setStatement} />
         <div className='exercise-block-tf-row'>
            <label className={'exercise-block-tf-option' + (correct ? ' active' : '')}>
               <input type='radio' checked={correct} onChange={() => setCorrect(true)} /> Правда
            </label>
            <label className={'exercise-block-tf-option' + (!correct ? ' active' : '')}>
               <input type='radio' checked={!correct} onChange={() => setCorrect(false)} /> Хибність
            </label>
         </div>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderTrueFalsePreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.statement) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   return (
      <div className='exercise-block-true-false-preview'>
         <p>{renderRichText(cfg.statement)}</p>
         <span className={'exercise-block-tf-badge' + (cfg.correct ? ' true' : ' false')}>{cfg.correct ? 'Правда' : 'Хибність'}</span>
      </div>
   );
}
